import { createUseStyles } from 'react-jss'
import { trafficRedDark, trafficRedDarkHover } from '../../../styles/const/colors'

const useStyles = createUseStyles({
  clearButton: {
    color: trafficRedDark,
    textAlign: 'center',
    width: '100%',
    display: 'block',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    marginTop: 16,
    outline: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      color: trafficRedDarkHover
    }
  }
})

export default useStyles
